import { DISC_DOT_BG, type DisciplineKey } from "./disciplineColor";

/**
 * Чип дисциплины DS (canon-session 2026-07-24): цветная точка + подпись.
 * Часть фиксированной легенды дисциплин. `label` — переведённая подпись
 * (i18n на стороне вызывающего; DS-исходник хардкодил русские имена —
 * убрано ради локализации).
 */
export function DisciplineChip({
  discipline,
  label,
  size = 9,
}: {
  discipline: DisciplineKey;
  /** переведённое имя дисциплины */
  label: string;
  /** диаметр точки в px (default 9) */
  size?: number;
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <span
        style={{ width: size, height: size }}
        className={`rounded-full shrink-0 ${DISC_DOT_BG[discipline]}`}
      />
      <span className="text-[13px] font-medium text-text-secondary">{label}</span>
    </span>
  );
}
